/**
 * Polyfills and other setup behavior
 */

import 'what-input'
import Promise from 'promise'
import RejectionTracking from 'promise/lib/rejection-tracking'

global.Promise = Promise

RejectionTracking.enable({ allRejections: true })
